import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Grid } from "../ecosystem";
import { LandingCard, PageHeading } from "../ecosystem/mybswh";

const TestProcedureLanding = (props) => {

    logUI("MBHWeb.UI.TestsProcedures.ComponentDidMount", new Date(), Tools.getURLPath());

    const onClickTile = (tileName, routeName) => {
        logUI(`MBHWeb.UI.TestsProceduresLanding.${tileName}.Clicked`, new Date(), Tools.getURLPath());
        if (routeName) {
            props.history.push(routeName);
        }
    };

    const headingText = "Tests & Procedures";

    const { isMyChartUser, disableMyChartMenuItems } = Tools.handleMychartUserShowOrHideMenuItems();
    const { proxyName } = Tools.getProxyName();

    const landingItems = [
        {
            title: "Results",
            body: "View results from your most recent lab work as well as tests from the past.",
            to: "/testresults",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => {
                onClickTile("Results");
            }
        },
        {
            title: "Upcoming",
            body: "Keep track of tests and procedures you need to follow up on.",
            to: "/upcomingtests",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => {
                onClickTile("Upcoming");
            }
        },
    ];

    return (
        <Grid className="body-content body-content--no-top-offset body-content--bg-gray test-procedures-landing-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading bodyOffset heading={headingText} proxyName={proxyName} />
                    <div className="row">
                        {
                            landingItems.map((item, i) => {
                                return item.show ? (
                                    <div className="col-12 col-lg-6">
                                        <LandingCard {...item} />
                                    </div>
                                ) : null
                            })
                        }
                    </div>
                </div>
            </div>
        </Grid>
    )
}

export default TestProcedureLanding